<template>
  <div
    v-if="isMobile"
    class="col-sm-12 p-0 mx-auto position-relative"
    :class="$route.path === '/iframeURL' ? '' : 'col-lg-4'"
  >

    <AppLoader :show="$store.state.isLoading" />

    <PromotionPopup
      :show="showPopup"
      :banners="bannerImages"
      @close="showPopup = false"
    />

    <NavBar v-if="
      !$route.path.includes('rule') &&
      $route.path !== '/auth/login' &&
      $route.path !== '/auth/register' &&
      $route.path !== '/iframeURL'
    " />

    <!-- :class="$route.path.includes('login') ? '' : 'middle-container'" -->
    <router-view style="position: relative; padding-bottom: 15rem; height: 100vh;" />

    <Footer v-if="
      !$route.path.includes('rule') &&
      !$route.path.includes('live-score')
    " />

    <ContactPopup />

    <audio
      controls
      ref="audioPlayer"
      v-show="false"
    >
      <source
        src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/samurai81/logo/samurai_song.mp3"
        type="audio/mp3"
      />
      Your browser does not support the audio element
    </audio>

    <van-overlay :show="isLuckyWheel">
      <div
        class="wrapper col-8"
        @click.stop
      >
        <LuckyWheel />
      </div>
    </van-overlay>
  </div>
  <div
    v-else
    class="h-100vh"
    style="background: black"
  >
    <div class="col-md-9 col-lg-4 mx-auto h-100vh">
      <iframe
        name="iframe1"
        :src="iframeRoute"
        class="iframe-style"
      ></iframe>
    </div>
  </div>
</template>
<script>
import { Dialog, NavBar } from "vant";
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import LuckyWheel from "../frontend/components/LuckyWheel.vue";
import AppLoader from "@/components/AppLoader.vue";
import PromotionPopup from "@/components/PromotionPopup.vue";
import ContactPopup from "@/components/ContactPopup.vue";

export default {
  components: {
    LuckyWheel,
    AppLoader,
    PromotionPopup,
    ContactPopup
  },
  data() {
    return {
      showPopup: true,
      bannerImages: [
        "https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/sabai88_welcome.webp",
        // "https://space-tech.sgp1.cdn.digitaloceanspaces.com/shwespin/banners/shwespin_welcome3.webp",
        // "https://space-tech.sgp1.cdn.digitaloceanspaces.com/shwespin/banners/shwespin_welcome2.webp",
      ],
      isLuckyWheel: false,
      websiteInfo: {},
      isMobile: false,
      iframeRoute: "https://play.sabai88.club/home",
    };
  },
  async mounted() {
    if (this.$route.query.code) {
      this.iframeRoute =
        "https://www.shwespin777.com/auth/register?code=" +
        this.$route.query.code;
    }
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
    this.getAgentContact()
  },
  computed: {
    ...mapGetters(["getFBOrder"]),
    ...mapState(["music"]),
  },

  watch: {
    music() {
      const audio = this.$refs.audioPlayer;
      if (this.music === true) {
        audio.play();
      } else {
        audio.pause();
      }
    },
  },

  methods: {
    testing() {
      this.isLuckyWheel = true;
      console.log("testing");
    },

    ...mapMutations(["setWholeFBMatches"]),
    ...mapActions(["fetchUser"]),
    closeModalOutside(event) {
      if (event.target.classList.contains("modal")) {
        this.$router.go();
      }
    },

    async getAgentContact() {
      try {
        const res = await this.axios.post("/user/agentcontact", {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        this.$store.commit('setAgentContact', res.data.data)
      } catch (e) {
        this.$store.commit('setAgentContact', null)
      }
    },
    // async fetchWebsiteData() {
    //   try {
    //     const res = await axios.get('/website-infos');
    //     this.websiteInfo = res.data.data[0];
    //     if (
    //       res.data.data[0].androidVersion !== this.$store.state.androidVersion
    //     ) {
    //       $('#version').modal('show');
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    openModalVoucher() {
      if (this.$store.state.fb_order.fb_matches.length === 0) {
        const dataError =
          this.$store.state.language === "en"
            ? "Please select some teams!"
            : "အသင်းတစ်ချို့ ရွေးပေးပါ။";
        this.dialog(dataError);
      } else {
        const matches = this.getFBOrder.fb_matches;
        if (!this.$store.state.betAmount) {
          $("#amount").modal("show");
        } else {
          for (let i = 0; i < matches.length; i += 1) {
            matches[i].bet_amount = this.$store.state.betAmount;
          }
          this.setWholeFBMatches(matches);
          $("#mobile-voucher").modal("show");
        }
      }
    },

    dialog(text) {
      Dialog.alert({
        message: text,
        confirmButtonText:
          this.$store.state.language === "en"
            ? "Go Back"
            : "နောက်သို့ပြန်သွားမည်။",
      }).then(() => {
        // on close
      });
    },
  },
};
</script>
<style scoped>
.iframe-style {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  z-index: 10000;
  background: #1d4f84 !important;
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  aspect-ratio: 1;
  display: grid;
  border: 4px solid #0000;
  border-radius: 50%;
  border-color: #ccc #0000;
  animation: l16 1s infinite linear;
}

.loader::before,
.loader::after {
  content: "";
  grid-area: 1/1;
  margin: 2px;
  border: inherit;
  border-radius: 50%;
}

.loader::before {
  border-color: #f03355 #0000;
  animation: inherit;
  animation-duration: 0.5s;
  animation-direction: reverse;
}

.loader::after {
  margin: 8px;
}

@keyframes l16 {
  100% {
    transform: rotate(1turn);
  }
}

.active-contact {
  transform: translate(0);
  transition: all 1s ease-in-out;
}

.box-contact .open-contact {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -12px;
  margin: auto;
}

.box-contact a img {
  width: 40px;
}

.box-contact {
  position: fixed;
  top: 60%;
  right: 0;
  border-radius: 12px 0 0 12px !important;
  background: linear-gradient(180deg,
      rgba(62, 62, 62, 0.5411764706) 0%,
      rgba(10, 10, 10, 0.5725490196) 100%);
  padding: 1rem 0.5rem 1rem 1.3rem;
  transform: translate(0);
  animation: slide 2s ease-in;
  z-index: 10;
}

.van-overlay {
  background: rgba(0, 0, 0, 0.4) !important;
}

.floating {
  position: fixed;
  width: 90px;
  z-index: 1;
  animation: floating 20s infinite;
  bottom: 130px;
  right: 0%;
}

#closeButton {
  border: none;
  background: none;
  position: absolute;
  left: -15px;
  font-size: 20px;
  font-weight: bold;
  color: #b7b7b7;
}

@keyframes float {
  0% {
    transform: translatey(0px);
  }

  50% {
    transform: translatey(-20px);
  }

  100% {
    transform: translatey(0px);
  }
}

.cart-number {
  top: -2px !important;
  left: -2px !important;
}

.cart-number {
  position: absolute;
  top: -3px;
  left: -3px;
  text-align: center;
}

.middle-container {
  min-height: 75vh;
}

@media (max-width: 768px) {
  .cart-container {
    font-size: 30px !important;
  }

  .social-contacts div {
    width: 60px !important;
    height: 60px !important;
    margin-top: 15px;
  }

  #social-contacts .badge-circle.badge-md {
    width: 1.5rem !important;
    height: 1.5rem !important;
  }

  .cart-container {
    visibility: visible;
    font-size: 16px;
  }

  .middle-container {
    /* min-height: 100vh; */
    margin: 0px !important;
    /* padding-top: 0.1rem !important; */
    /* margin-bottom: 50px !important; */
  }
}
</style>
